import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
    DefaultExportSearch,
    ExportSearchResource,
    ExportSearchResourceOptions,
    Menu, ResourceExportParams, ResourcesExportParams, ResourcesInstanceItem,
    Tab,
} from '@app/interfaces/rm/resources';
import { STColumn } from '@app/interfaces/sys/st';
import { MultipleInputSearchComponent } from '@app/shared/components/multiple-input-search/multiple-input-search.component';
import { environment } from '@env/environment';
import { ResourcesService } from '@services/rm/resources.service';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-resource-export',
    templateUrl: './resource-export.component.html',
    styleUrls: ['./resource-export.component.less'],
})
export class ResourceExportComponent implements OnInit {
    @ViewChild('inputTag') inputTag!: MultipleInputSearchComponent;
    @Output() getImportResourceType = new EventEmitter();
    isVisible = false;
    submitLoading = false;
    loading = false;
    menus: Menu[] = [];
    originMenus: Menu[] = [];
    keywordList: string[] = [];
    selectIds: number[] = [];
    columns: STColumn[] = [
        {
            type: 'selection',
            width: '50px',
        },
        {
            title: 'Name',
            index: 'name',
            width: '120px',
        },
        {
            title: 'Column contain keyword',
            render: 'keyword',
        },
    ];
    // params: ResourceExportParams = {};
    baseUrl = environment.api.services.rm + '/resources';
    allSelectIds: {
        [key: string]: number[]
    } = {};
    isImport = false;

    constructor(private message: NzMessageService,
        private http: HttpClient,
        private resourcesService: ResourcesService) {
    }

    ngOnInit(): void {
    }

    open(menus: Menu[], isImport: boolean = false): void {
        dayjs.extend(timezone);
        this.loading = false;
        this.keywordList = [];
        this.isImport = isImport;
        this.menus = menus?.map(item => {
            return {
                ...item,
                checked: false,
                indeterminate: false,
                children: item?.children?.map(child => {
                    return {
                        ...child,
                        checked: false,
                    };
                }) || [],
            };
        });
        this.originMenus = JSON.parse(JSON.stringify(this.menus));
        this.isVisible = true;
    }

    categoryChecked(selectItemIndex: number): void {
        const selectItem = this.menus[selectItemIndex];
        const { checked, children } = selectItem;
        selectItem.indeterminate = false;
        this.menus[selectItemIndex].children = children?.map(item => {
            return {
                ...item,
                checked,
                indeterminate: false,
            };
        }) || [];
    }

    close(): void {
        this.isVisible = false;
        this.keywordList = [];
        this.resetSelect();
    }

    resetSelect(): void {
        this.allSelectIds = {};
    }

    menuChecked(selectMenuIndex: number): void {
        const selectItem = this.menus[selectMenuIndex];
        const { children } = selectItem;
        const allChecked = children?.every(item => item.checked);
        const someChecked = children?.some(item => item.checked);
        if (allChecked) {
            selectItem.indeterminate = false;
            selectItem.checked = true;
            return;
        }
        if (someChecked) {
            selectItem.indeterminate = true;
            selectItem.checked = false;
        } else {
            selectItem.indeterminate = false;
            selectItem.checked = false;
        }
    }

    getSelectResource(): Tab[] {
        let selectedArr: Tab[] = [];
        this.menus?.forEach(item => {
            item?.children?.forEach((child) => {
                if (!child.checked) {
                    return;
                }
                selectedArr = [...selectedArr, child];
            });
        });
        return selectedArr;
    }

    // import file get select type
    getImportType(): void {
        const selectedArr = this.getSelectResource();
        this.getImportResourceType.emit(selectedArr);
    }

    async submit(): Promise<void> {
        try {
            const timeZone = dayjs.tz.guess();
            if (this.keywordList.length === 0) {
                const selectedArr = this.getSelectResource();
                if (selectedArr?.length <= 0) {
                    this.message.warning('Please select one resource');
                    return;
                }
                // let url = '';
                this.submitLoading = true;
                // let hasTypeList = false;
                // let hasResourceDefinitionList = false;
                // let hasResourceTypeList = false;
                // selectedArr?.forEach((item, index) => {
                //     const { type } = item;
                //     if (!type) {
                //         hasTypeList = true;
                //     }
                //     if (type === 'customize') {
                //         hasResourceDefinitionList = true;
                //     }
                //     if (type === 'other') {
                //         hasResourceTypeList = true;
                //     }
                //     const urlType = !type ? 'typeList' : (type === 'customize' ? 'resourceDefinitionList' : 'resourceTypeList');
                //     const urlValue = item.value || item.key;
                //     const urlItem = `${urlType}=${urlValue}`;
                //     index === selectedArr?.length - 1 ? url += urlItem : url += `${urlItem}&`;
                // });
                // if (!hasTypeList) {
                //     url += '&typeList=';
                // }
                // if (!hasResourceTypeList) {
                //     url += '&resourceTypeList=';
                // }
                // if (!hasResourceDefinitionList) {
                //     url += '&resourceDefinitionList=';
                // }
                // await this.resourcesService.exportResources(url, timeZone);
                const typeList: string[] = [];
                const resourceTypeList: string[] = [];
                const resourceDefinitionList: number[] = [];

                selectedArr?.forEach((item) => {
                    const { type } = item;
                    const value = item.value || item.key;

                    if (!type) {
                        typeList.push(value as string);
                    } else if (type === 'customize') {
                        resourceDefinitionList.push(Number(value));
                    } else if (type === 'other') {
                        resourceTypeList.push(value as string);
                    }
                });
                const params: ResourcesExportParams = {
                    timeZone,
                };

                if (typeList.length > 0) {
                    params.typeList = typeList;
                }
                if (resourceTypeList.length > 0) {
                    params.resourceTypeList = resourceTypeList;
                }
                if (resourceDefinitionList.length > 0) {
                    params.resourceDefinitionList = resourceDefinitionList;
                }
                await this.resourcesService.exportResource(params);
                this.close();
            } else {
                const params = this.getExportParams();
                if (Object.keys(params).length <= 0) {
                    this.message.warning('Please select one resource');
                    return;
                }
                this.submitLoading = true;
                await this.resourcesService.export({
                    ...params,
                    timeZone
                });
            }
        } finally {
            this.submitLoading = false;
        }
    }

    formatResources(res: ExportSearchResource): ExportSearchResourceOptions {
        let data: ExportSearchResourceOptions = {};
        Object.keys(res)?.forEach(key => {
            if (key === 'resourcesInstance') {
                const resourcesInstance = res.resourcesInstance;
                resourcesInstance?.forEach(instanceItem => {
                    const instanceKey = instanceItem.resourceDefinitionId || instanceItem.resourceType;
                    data = {
                        ...data,
                        [instanceKey]: instanceItem.searchVOList,
                    };
                });
            } else {
                if (key === 'baseStation') {
                    data = {
                        ...data,
                        BASE_STATION: res.baseStation || [],
                    };
                } else {
                    const upperCaseKey = key.toUpperCase().toString();
                    data = {
                        ...data,
                        [upperCaseKey]: res[key as keyof DefaultExportSearch] || [],
                    };
                }
            }
        });
        return data;
    }

    async fetchData(): Promise<void> {
        try {
            this.loading = true;
            const res = await this.resourcesService.searchResource({
                keywordList: this.keywordList,
            });
            const options = this.formatResources(res);
            let data: Menu[] = [];
            this.menus.forEach((categoryItem, cateGoryIndex) => {
                let arr: Tab[] = [];
                categoryItem.children?.forEach((resourceItem, resourceIndex) => {
                    const key = resourceItem.value || resourceItem.key;
                    if (!options[key] || options[key]?.length === 0) {
                        return;
                    }
                    arr = [...arr, {
                        ...resourceItem,
                        checked: false,
                        active: cateGoryIndex === 0 && resourceIndex === 0,
                        tableData: options[key],
                    }];
                });
                if (!arr || arr?.length === 0) {
                    return;
                }
                data = [...data, {
                    ...categoryItem,
                    checked: false,
                    active: true,
                    children: [...arr],
                }];
            });
            this.menus = JSON.parse(JSON.stringify(data));
        } finally {
            this.loading = false;
        }
    }

    onSearch(): void {
        this.resetSelect();
        this.keywordList = [...this.inputTag.getTags() || []];
        this.menus = JSON.parse(JSON.stringify(this.originMenus));
        if (!this.keywordList || this.keywordList.length === 0) {
            return;
        }
        this.fetchData();
    }

    getExportParams(): ResourceExportParams {
        let params: ResourceExportParams = {} as ResourceExportParams;
        Object.keys(this.allSelectIds)?.forEach(item => {
            let typeKey: string = item;
            const arr = typeKey?.split('&');
            const type = arr && arr.length > 1 ? arr[arr.length - 1] : null;
            if (type) {
                arr.pop();
                typeKey = arr.join();
            }
            const key = typeKey;
            const ids = this.allSelectIds[item] || [];
            if (ids.length <= 0) {
                return;
            }
            if (type === 'customize' || type === 'other') {
                const itemData = {
                    resourceType: type === 'other' ? key : null,
                    resourceDefinitionId: type === 'other' ? null : Number(key),
                    resourceInstanceIdList: [...ids],
                };
                params = {
                    ...params,
                    resourcesInstanceList: [...(params?.resourcesInstanceList || []), itemData] as ResourcesInstanceItem[],
                };
            } else {
                const lowerName = key.toLowerCase() + 'IdList';
                if (key === 'BASE_STATION') {
                    params = {
                        ...params,
                        baseStationIdList: [...ids],
                    };
                } else {
                    params = {
                        ...params,
                        [lowerName]: [...ids],
                    };
                }
            }
        });
        return params;
    }

    handleSelect(ids: number[], tab: Tab): void {
        const type = tab?.type;
        const key = tab.value || tab.key;
        const keys = Object.keys(this.allSelectIds) || [];
        const name = (type === 'customize' || type === 'other') ? `${key}&${type}` : `${key}`;
        if (keys.includes(key as string)) {
            this.allSelectIds[key] = [...ids];
        } else {
            this.allSelectIds = {
                ...this.allSelectIds,
                [name]: [...ids],
            };
        }
    }
}
